// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__LbP0S","tab":"Tabs_tab__5NCFA","activeTab":"Tabs_activeTab__PEMrh","tabContent":"Tabs_tabContent__c_VR4","activeContent":"Tabs_activeContent__M_NYy"};